import { RootStoreModel } from "@redux/reducers";
import i18n from "@src/locales";
import {
  Avatar,
  Button,
  Col,
  Divider,
  Drawer,
  Dropdown,
  Layout,
  Menu,
  MenuProps,
  Row,
  Space,
  Tooltip
} from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, useHistory } from "react-router-dom";
import { MSALObjLogin } from "../../auth/authInstance";
import { getTenants, swichTenant } from "../../axios/api.account";
import {
  FetchingAccount,
  SwitchMenu,
  UpdateRegisShow
} from "../../redux/actions";
import Store from "../../redux/store";
import { gaEvent } from "../../withTracker";
import "./header.scss";
import { CloseOutlined } from "@ant-design/icons";
const { Header } = Layout;

interface HeaderProps {
  copilotOpen: boolean;
  setCopilotOpen: (open: boolean) => void;
}

export function SiteHeader({ copilotOpen, setCopilotOpen }: HeaderProps) {
  const history = useHistory();
  const [collapse, setCollapse] = useState(false);
  const [teList, setTenantList] = useState<any[]>([]);
  const [open, setOpen] = useState(false);

  const { t } = useTranslation();

  const login = (e: any) => {
    e.preventDefault();
    MSALObjLogin();
  };

  const logout = (e: any, user: any) => {
    e.preventDefault();
    localStorage.removeItem('jt');
    window.location.href='/';
    //MSALObjLogout(user);
  };

  const accountClick = () => {
    Store.dispatch(UpdateRegisShow(true))
  }
  const user = useSelector((state: RootStoreModel) => state.userState);
  const goHelp = () => {
    // history.push("/home/help");
    // Store.dispatch(SwitchMenu("help"));
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  // useEffect(() => {
  //   getTenantList({});
  // }, [])
  const getTenantList = (par: any={}) => {
    if(teList.length==0){
      if(user.tokenSuccess){
        getTenants(par).then(c => {
          setTenantList(c);
        })
      }
    }
    

  }
  const tenantSwich=(item:any)=>{
    console.log(item.id,user.account.tenantId)
    if(item.id == user.account.tenantId) return;
    swichTenant(item.id).then(c=>{
      Store.dispatch(FetchingAccount());
      window.location.reload();
    })
  }
  const showMenu=(key:string)=>{
    if( user.account.modules){
      let keys = user.account.modules.map((c:any)=>c.key);
      if(keys.filter((c:string)=>c == key).length>0){
        return true;
      }else{
        return false;
      }
    }else{
      return false;
    }
  }
  const menuClick=(key:string)=>{
    let menuRoute = user.account.modules.filter((c:any)=>c.key == key)[0]
    menuRoute = getMenuFirst(menuRoute);
    if(menuRoute)
    {
      Store.dispatch(SwitchMenu(key));
      history.push({pathname:menuRoute.url});
    }
  }
  const getMenuFirst:any=(menuRoute:any)=>{
    if(menuRoute?.childModules && menuRoute?.childModules.length>0){
      return getMenuFirst(menuRoute?.childModules[0])
    }else{
      return menuRoute;
    }
  }
  const items: MenuProps['items'] = teList.map(item => {
    return {
      key: item.id,
      label: (<>
        <Button 
          type="link" 
          key={item.id} 
          onClick={() => { tenantSwich(item); gaEvent("heander","onClick","tenantSwich")} } 
          style={{ color: "#000",width:"100%"}}
        >{item.name}</Button>
      </>)
    }
  });
  
  return (
    (<Header className="siteHeader">
      <nav className="navbar navbar-expand-lg navbar-dark" style={{paddingTop:0,paddingBottom:0}}>
        <div className="container-fluid px-4">
          <a className="navbar-brand py-0 pl-3" href="/" style={{marginRight: 0, lineHeight: "20px"}}>
            {process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") &&
              <img style={{width: 52}} src="/images/title.jpg"></img>
            }
            {!process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") &&
              <img style={{width: 52}} src="/images/title.jpg"></img>
            }
          </a>
          <div
            className={`collapse navbar-collapse ${collapse ? "show" : ""}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav me-auto  my-lg-0">
                {/* <li className="nav-item">
                  {user.isLogin && (
                    <Dropdown placement="bottomCenter" arrow menu={{items}} trigger={['click']}>
                      <a className="nav-link text-white" onClick={()=>{getTenantList()}}>
                        <Space>
                          <img src="/images/title.png" width={32} alt="" />
                        </Space>
                      </a>
                    </Dropdown>
                  )}
                </li> */}
                <li className="nav-item">
                  <div style={{fontWeight:500,marginLeft:8,lineHeight:"52px",color:"#000",fontSize:24}}>
                    <div>{process.env.REACT_APP_API_URL?.includes("mdmapi.willingtek.com") ?
                        "Willingtek" : "Willingtek"
                      }</div>
                  </div>
                </li>
                <li  className="nav-item">
                  <div style={{width:1,height:56,backgroundColor:"#EEEEEE",marginLeft:20,marginRight:20}}></div>
                </li>
                <li className="nav-item">
                {user.isLogin && (
                    <Dropdown placement="bottomCenter" arrow menu={{items}} trigger={['click']}>
                      <a className="nav-link text-white" onClick={()=>{getTenantList()}}>
                        <Space style={{paddingLeft:16,height:32,paddingRight:16,marginTop:4,backgroundColor:"#F4F6F7"}}>
                          <img style={{paddingTop:"9px"}} src="/images/head/home.png" width={16} alt="" />
                          <div style={{lineHeight:"",fontSize:20,paddingLeft:20,color:"#666"}}>{user.account.tenantName}</div>
                          <img style={{paddingTop:"9px"}} src="/images/head/dow.svg" width={16}  alt="" />
                        </Space>
                      </a>
                    </Dropdown>
                  )}
                </li>
          
            </ul>
            <div className="my-lg-0">
              <ul className="navbar-nav">
              <li className="nav-item">
                <Space>
                  <img onClick={()=>{setCopilotOpen(true)}} width={28} style={{cursor:"pointer",paddingTop:"6px",paddingRight:'4px'}}  src='/images/ai-logo.png'></img>
                  <img width={18} style={{cursor:"pointer",paddingTop:"6px"}}  src='/images/head/bell.png'></img>
                  <img onClick={goHelp} width={18} style={{marginLeft:8,cursor:"pointer",paddingTop:"6px"}} src='/images/head/question-circle.png'></img>
                  <Dropdown dropdownRender={() => (
                    <Menu 
                      onClick={(e) => { i18n.changeLanguage(e.key) }} 
                      selectable={true} 
                      defaultSelectedKeys={[i18n.language]}
                    >
                      <Menu.Item key="zh" style={{width: 145, textAlign: "center"}}>中文</Menu.Item>
                      <Menu.Item key="en" style={{width: 145, textAlign: "center"}}>English</Menu.Item>
                    </Menu>
                  )}>
                    <div className="nav-link" style={{color:"#666",lineHeight:"46px"}}>
                      {i18n.language=="zh"?"简体":"English"}
                    </div>
                  </Dropdown>
                 
                </Space>
      
              </li>
              <li  className="nav-item">
                <div style={{width:1,height:56,backgroundColor:"#EEEEEE",marginLeft:20,marginRight:20}}></div>
              </li>
                {user.isLogin && (
                  <li
                    className="nav-item"
                  >
                    <Dropdown 
                      placement="bottomCenter" 
                      trigger={['click']} 
                      dropdownRender={() => (
                        <Menu>
                          {
                            user?.account?.role === "SuperAdmin" && (
                              <Menu.Item>
                                <NavLink 
                                  to="/tenant" 
                                  className="nav-link" 
                                  style={{ color: "#666" }}
                                >
                                  <Space>
                                    <Avatar size={14} src="/images/mainAccountIcon.svg" style={{marginBottom: 2}}/>
                                    <span>{t("Manage master account")}</span>
                                  </Space>
                                </NavLink>
                              </Menu.Item>
                            )
                          }
                          {user.isLogin && (
                            <Menu.Item>
                              <li className="nav-item">
                                <NavLink
                                  to="/home/index"
                                  className="nav-link"
                                  activeClassName="active"
                                >
                                  <Space>
                                    <Avatar size={14} src="/images/consoleIcon.svg" style={{marginBottom: 2}}/>
                                    <span>{t("Console")}</span>
                                  </Space>
                                </NavLink>
                      
                              </li>
                            </Menu.Item>
                          )}
                          <Menu.Item>
                            <NavLink
                              to="/"
                              className="nav-link"
                              exact
                              activeClassName="active"
                            >
                              <Space>
                                <Avatar size={14} src="/images/backhomeIcon.svg" style={{marginBottom: 2}}/>
                                <span>{t("Back Home")}</span>
                              </Space>
                            </NavLink>
                          </Menu.Item>
                          {user.isLogin ? (
                            <Menu.Item>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  href="/"
                                  onClick={(e) =>{
                                    logout(e, user?.account?.account);
                                  }}
                                  style={{ color: "#666" }}
                                >
                                  <Space>
                                    <Avatar size={14} src="/images/signoutIcon.svg" style={{marginBottom: 2}}/>
                                    <span>{t("Sign out")}</span>
                                  </Space>
                                </a>
                              </li>
                            </Menu.Item>
                          ) : (
                            <Menu.Item>
                              <li className="nav-item">
                                <a className="nav-link" href="/login">
                                  {t("Sign in")}
                                </a>
                              </li>
                            </Menu.Item>
                          )}
                        </Menu>
                      )}
                    >
                      <a className="nav-link">
                        <Space>
                          
                          <Tooltip title={user?.account?.email}>
                            <span style={{color:"#666",lineHeight:"48px",fontSize:20}}>{user.account.email}</span>
                          </Tooltip>
                          <img src="/images/head/user.png" width={40}></img>
                        </Space>
                      </a>
                    </Dropdown>
                  </li>
                )}
                {!user.isLogin && (
                  <li className="nav-item">
                    <a className="nav-link" style={{color: "white"}} href="/" onClick={(e)=>{login(e);gaEvent("heander","onClick","tenantSwich")}}>
                      {t("Sign in")}
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </nav>
      <Menu mode="horizontal" theme="dark" selectedKeys={[user.menuKey]} onClick={(e)=>{
        menuClick(e.key)
      }}  
      style={{lineHeight:"42px",fontSize:18,backgroundColor:"#2C3644",color:"#fff"}}
      //style={{lineHeight:"42px",fontSize:18,backgroundColor:"#D32D26",color:"#fff"}}
      >
        <Menu.Item style={{marginLeft:30}} key={"Index"}>{t("主页")}</Menu.Item>
        <Menu.Item style={{marginLeft:30}} key={"DeviceManage"}>{t("设备管控")}</Menu.Item>
        <Menu.Item style={{marginLeft:30}} key={"AppAndContent"}>{t("应用与内容")}</Menu.Item>
        <Menu.Item style={{marginLeft:30}} key={"Enrollment"}>{t("注册")}</Menu.Item>
        <Menu.Item style={{marginLeft:30}} key={"Report"}>{t("报告")}</Menu.Item>
          <Menu.Item style={{marginLeft:30}} key={"Setting"}>{t("设置")}</Menu.Item>
      </Menu>
      <Drawer rootStyle={{top:"72px"}} 
        title={t("帮助")} 
        closable={false} 
        placement="right" 
        onClose={onClose} 
        open={open} 
        extra={
          <Space>
            <Button type="text" icon={<CloseOutlined />} size={"large"} onClick={onClose}>
            </Button>
          </Space>
        }
      >
        <Row style={{ width: "100%" }}>
            <div>
                <div>
                    <Row style={{ marginTop: 21, marginLeft: 21 }}>
                      <Col id="helpbook" span={12} style={{textAlign:"center"}}>
                        <Avatar size={70}>
                          <a href="/opmanual.pdf" target="blank"><img src="/images/book.png" style={{width:"60px"}}></img></a>
                        </Avatar>
                      </Col>
                      <Col id="helpAnswer" span={12} style={{textAlign:"center"}}>
                        <Avatar size={70}>
                          <a href="/faq.pdf" target="blank"><img src="/images/discussion.png" style={{width:"50px"}}></img></a>
                        </Avatar>
                      </Col>
                      <Col span={12} style={{textAlign:"center"}}>
                        <p><a href="/opmanual.pdf" style={{color:"#F3AA86"}} target="blank">使用手册</a></p>
                      </Col>
                      <Col span={12} style={{textAlign:"center"}}>
                        <p><a href="/faq.pdf" style={{color:"#95D9A4"}} target="blank">常见问题</a></p>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: 21, marginLeft: 21 }}>
                      <Col id="helpTK" span={12} style={{textAlign:"center"}}>
                        <Avatar size={70}>
                          <a href="/serviceagreement.pdf" target="blank"><img src="/images/term.png" style={{width:"50px"}}></img></a>
                        </Avatar>
                      </Col>
                      <Col id="helpYS" span={12} style={{textAlign:"center"}}>
                        <Avatar size={70}>
                          <a href="/privacy.pdf" target="blank"><img src="/images/service.png" style={{width:"50px"}}></img></a>
                        </Avatar>
                      </Col>
                      <Col span={12} style={{textAlign:"center"}}>
                        <p><a href="/serviceagreement.pdf" style={{color:"#94D5FA"}} target="blank">使用条款</a></p>
                      </Col>
                      <Col span={12} style={{textAlign:"center"}}>
                        <p><a href="/privacy.pdf" style={{color:"#B5AEFF"}} target="blank">隐私声明</a></p>
                      </Col>
                    </Row>
                </div>
                <Divider />
                <div>
                    <div className="newHelpTitle"><img src="/images/service_line_b.png" className="newHelpIcon" />{t("联系我们")}</div>
                    <div className="newHelpContact">
                        <p style={{marginBottom:"0px"}}>{t("邮箱")}：<a href="mailto:mdm@willingtek.com">mdm@willingtek.com</a></p>
                        <p>{t("工作日")} 9:00-18:00</p>
                    </div>
                </div>
            </div>
        </Row>
      </Drawer>
    </Header>)
  );
}